import EmployeePerformanceList from '../components/Employees/EmployeePerformance'
import NavbarLayout from '../components/NavbarLayout'


const EmployeePerformance = () => {
    return (
        <div className="screenshots-wrapper-page">
            <NavbarLayout>
                <EmployeePerformanceList />

            </NavbarLayout>
        </div>
    )
}

export default EmployeePerformance